<app-navigation-wrapper [userName]="userName" [appName]="'Restaurant Network Dashboard'"
    (signout)="logout()">
    <app-nav-tab [label]="'Health'" [routerLink]="'/health'"></app-nav-tab>
    <app-nav-tab *appHasAnyAuthority="['UPDATE', 'ADMIN', 'INTL', 'DFS', 'CRADLEPOINT_PRO']" [label]="'Automation'" [routerLink]="'/automation'"></app-nav-tab>
    <app-nav-menu-item [label]="'Help'" (selected)="openHelpDialog()"></app-nav-menu-item>
    <div class="container">
        <div class="row">
            <div class="col">
                <router-outlet #outlet="outlet"></router-outlet>
            </div>
        </div>
    </div>
</app-navigation-wrapper>
